import useSWR from 'swr';
import { sdk } from '@/sdk';
import { Product } from '@shared/types/product';

const useProductSearch = (searchQuery?: string, skus?: string[], limit?: number, storeKey?: string) => {
  // Commented out for faster login redirect - product search can be loaded lazily
  // const { data, isLoading } = useSWR(['/action/product/query', searchQuery, skus, limit], () =>
  //   sdk.composableCommerce.product.query({ query: searchQuery, skus, limit, storeKey }),
  // );

  // Provide empty data for faster initial load
  const data = { isError: false, data: { items: [] } };
  const isLoading = false;

  const products = data?.isError ? [] : ((data?.data.items as Product[]) ?? []);

  return { products, isLoading };
};

export default useProductSearch;